import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import cn from '@components/utils/cn'

const TooltipProvider = ({
  delayDuration = 100,
  ...props
}: ComponentPropsWithoutRef<typeof TooltipPrimitive.Provider> & { delayDuration?: number }) => (
  <TooltipPrimitive.Provider delayDuration={delayDuration} {...props} />
)

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = ({
  className,
  sideOffset = 4,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
  ref?: Ref<ComponentRef<typeof TooltipPrimitive.Content>>
}) => (
  <TooltipPrimitive.Portal>
    <div className="tailwind">
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        collisionPadding={16}
        className={cn(
          'tw:z-50 tw:overflow-hidden tw:flex tw:flex-col tw:items-start tw:p-3 tw:text-white tw:text-xs tw:font-normal tw:leading-tight tw:rounded-lg tw:border tw:border-gray-900 tw:bg-gray-900 tw:shadow-lg tw:animate-in tw:fade-in-0 tw:zoom-in-95 tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=closed]:zoom-out-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2 tw:max-w-[350px]',
          className
        )}
        {...props}
      />
    </div>
  </TooltipPrimitive.Portal>
)

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
